






































































import Vue from "vue";

import { FastOrderModal } from "@/components/organisms/Modal";

import { IProduct } from "@/services/interfaces";
import { ICartPayload, IOrderItem } from "@/services/interfaces/requests";

import HeaderColumn from "./blocks/HeaderColumn.vue";
import { RowPicker } from "./blocks/RowPicker";
import { IHeader } from "./interfaces";

import { cartModule, commonModule } from "@/plugins/store-accessors";

interface IState {
  hover: string | null;
}

export default Vue.extend({
  name: "catalog-table",
  components: { FastOrderModal, HeaderColumn, RowPicker },
  props: {
    highlightText: { type: String, default: "" },
    headers: { type: Array as () => IHeader[], default: () => [] },
    viewType: { type: String, default: "" },
    setType: { type: Function, default: () => null },
    changeSort: { type: Function, default: () => null },
    rows: { type: Array, default: () => [] },
    quantities: { type: Object, default: () => ({}) },
    changeQuantity: { type: Function, default: () => null },
    rowClickHandler: { type: Function, default: () => null },
    removeFromCart: { type: Function, default: () => null },
    afterOrder: { type: Function, default: () => null },
    context: { type: String, default: "catalog" },
    sort: { type: Object, default: () => ({}) },
    fetching: { type: Boolean, default: false },
    excludedIds: { type: Array, default: () => [] },
    allSelected: { type: Boolean, default: false },
  },
  data(): IState {
    return {
      hover: null,
    };
  },
  computed: {
    getOrder() {
      return cartModule.getOrder;
    },
    columnsList(): string[] {
      return this.headers.map((column: IHeader) => {
        return column.key as string;
      });
    },
  },
  updated() {
    commonModule.SET_INTERACTIVE();
  },
  methods: {
    closeHandler() {
      cartModule.ORDER_CLEAR();
      this.afterOrder();
    },
    cartAddHandler(data: ICartPayload) {
      cartModule.addProduct(data);
    },
    orderAddHandler(item: IProduct, quantity = 1) {
      const parsedPrice: number =
        typeof item.price === "string" ? parseFloat(item.price) : item.price;
      const orderItem: IOrderItem = {
        id: item.id,
        quantity: quantity,
        price: parsedPrice,
        price_type: item.price_type,
        total_price: parsedPrice && parsedPrice * quantity,
      };
      cartModule.ORDER_SET([orderItem]);
    },
    orderSendHandler(comment: string) {
      const payload = {
        products: this.getOrder,
        comment,
        isFromCart: this.context === "cart",
      };
      return cartModule.createOrder({ data: payload });
    },
    hoverHandler(name: string) {
      this.hover = name;
    },
    selectedValues({ id, value }: any) {
      this.$emit("select", { id, value });
    },
  },
});
